module.exports = {
  bookkeeper: {id: "58415e4ac742b30f4aea94d7", defaultPath: "/cab/finance/operations"},
  monitoring: {id: "63a42ae9370e66f9f0311bb5", defaultPath: "/cab/reports/sent_messages"}
}